import { Col } from "reactstrap";
import NewOrders from "./NewOrders";
import ShippedOrders from "./ShippedOrders";
import CancelledOrders from "./CancelledOrders";
import DtataTableOrderHistory from "./DtataTableOrderHistory";

const OrderHistoryData = () => {
  return (
    <Col sm="12">
      <NewOrders />
      <ShippedOrders />
      <CancelledOrders />
      <DtataTableOrderHistory/>
    </Col>
  );
};

export default OrderHistoryData;
